<template>
  <ul :id="`tree-node-actions-${nodo.id}`">
    <li>
      <a
        class="a-tooltip-primary a-tooltip-bottom"
        :data-tooltip-text="$t('mEditionAssetContentsTreeNodeActions.actions.comments')"
        href="#"
        @click.prevent="selectNode"
      >
        <i class="fas fa-comments"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MoleculeEditionMapPathTreeNodeActionsComments',

  props: {
    contenido: Object,
    nodo: Object
  },

  methods: {
    selectNode () {
      this.$store.commit('setAssetSelectedNode', Object.assign({}, this.nodo))
    }
  }
}
</script>
